<template>
  <MainComponent />
</template>

<script>
import MainComponent from './components/main.vue'

export default {
  name: 'App',
  components: {
    MainComponent
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0; /* �Ƴ���߾� */
  padding: 0; /* �Ƴ��ڱ߾� */
}

</style>
